import './main.scss';

// jQuery
import '../common/js/jqueryHandler';

// jQuery UI
import 'jquery-ui/themes/base/core.css';
import 'jquery-ui/themes/base/theme.css';
import 'jquery-ui/themes/base/autocomplete.css';
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/autocomplete';

// jQuery Select2
import '../common/js/select2/select2.full.min';
import '../common/css/select2/select2.min.css';
import '../common/css/select2/select2_dso.scss';

// Slick
import '../common/js/slick/slick.min';
import '../common/js/slick/slick-dso.js';
import '../common/css/slick/slick.min.css';
import '../common/css/slick/slick-theme.min.css';
import '../common/css/slick/slick-dso.scss';
import '../common/css/slick/slick.fix.css';

// Search engine
import {OverlappingMarkerSpiderfier} from '../common/js/OverlappingMarkerSpiderfier.1.0.3.min.js';
import MarkerClusterer from '@google/markerclusterer';
import GuidedSearchPopin from '../search/js/GuidedSearchPopin';

GuidedSearchPopin.init();

window.OverlappingMarkerSpiderfier = OverlappingMarkerSpiderfier;
window.MarkerClusterer = MarkerClusterer;

// Main site common scripts
import '../common/js/oni.autocomplete';
import '../pif/main.js';

// DSO
import '../common/js/dso/dso';
